import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';
Vue.component('mdmCarousel', Carousel);
Vue.component('mdmSlide', Slide);